import React from "react";

/**
 * Contract Holder Program Performance "Reports" More Info Component
 * @returns {Element}
 * @constructor
 */
export default function Reports() {
  return (<tr className="extra-info">
    <td colSpan={6}>
      <div>
        <h6 className="bold">Reports</h6>
        <p>The Reports rating is based on the contract holder ensuring that all required reports are submitted to
          the SEWP Program Office in a timely manner and accurate.
          <br /><em>*Reports are as defined in section A.1.1. of the SEWP contracts </em></p>

        <ul className="performance-desc-range">
          <li className="excellent">Excellent - 100%</li>
          <li className="very-good">Very Good - 90-99%</li>
          <li className="good">Good - 80-89%</li>
          <li className="fair">Fair - 70-79%</li>
          <li className="poor">Poor - &#60; 70%</li>
        </ul>

        <ul>
          <li><strong>Excellent</strong> = All items 100% on time and accurate</li>
          <li><strong>Very Good</strong> = Average timeliness and accuracy between 90-99%</li>
          <li><strong>Good</strong> = Average timeliness and accuracy between 80-89%</li>
          <li><strong>Fair</strong> = Average timeliness and accuracy between 70-79%</li>
          <li><strong>Poor</strong> = Average timeliness and accuracy &lt; 70%</li>
          <li><strong>Neutral</strong> = Contract Holder has not received any orders or performed any work on the
            SEWP contracts to date
          </li>
        </ul>
      </div>
    </td>
  </tr>);
}